import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { BlogConfigService } from "./blog.config";
import { BlogPost } from "./blog.model";

@Injectable({
	providedIn: "root",
})
export class BlogService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: BlogConfigService
	) {}

	getFeed(count = 3): Observable<BlogPost[]> {
		return this.httpClient.get<BlogPost[]>({
			url: this.config.getFeedUrl(),
			searchParams: { count },
		});
	}
}
